// import { ContentState, EditorState, Modifier } from 'draft-js';
// import htmlToDraft from 'html-to-draftjs';
// import React from 'react';
// import { Editor } from "react-draft-wysiwyg";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import styled from 'styled-components';

// const toolbarOptions = {
//   options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'history'],
//   inline: {
//     options: ['bold', 'italic', 'underline'],
//   },
//   blockType: {
//     inDropdown: true,
//   },
//   fontSize: {
//     className: 'custom-fontsize',
//   },
//   list: {
//     inDropdown: false,
//   },
//   textAlign: {
//     inDropdown: false,
//   },
// };

// function WYSIWYG({ editorState, onEditorStateChange, placeholder }) {

//   const handlePastedText = (text, html, state) => {
//     // Fallback to plain text if no HTML
//     if (!html) return false;

//     // Protect against very large pastes
//     if (html.length > 100000) {
//       alert('Pasted content is too large. Please paste smaller portions.');
//       return true; // Handled (prevent default)
//     }

//     try {
//       const blocksFromHtml = htmlToDraft(html);
//       if (!blocksFromHtml || !blocksFromHtml.contentBlocks) return false;

//       const { contentBlocks, entityMap } = blocksFromHtml;
//       const fragment = ContentState.createFromBlockArray(contentBlocks, entityMap).getBlockMap();

//       const newContentState = Modifier.replaceWithFragment(
//         state.getCurrentContent(),
//         state.getSelection(),
//         fragment
//       );

//       const newEditorState = EditorState.push(state, newContentState, 'insert-fragment');

//       // Preserve cursor position
//       onEditorStateChange(
//         EditorState.forceSelection(newEditorState, newContentState.getSelectionAfter())
//       );

//       return true; // Handled
//     } catch (error) {
//       console.warn('Paste processing failed, falling back to plain text:', error);
//       return false; // Let editor handle as plain text
//     }
//   };

//   return (
//     <QuillView>
//       <Editor
//         editorState={editorState}
//         toolbar={toolbarOptions}
//         handlePastedText={handlePastedText || defaultHandlePaste}
//         wrapperClassName="rdw-editor-wrapper"
//         editorClassName="rdw-editor-main"
//         toolbarClassName="rdw-editor-toolbar"
//         onEditorStateChange={onEditorStateChange}
//         placeholder={placeholder}
//       />
//     </QuillView>
//   );
// }

// export default WYSIWYG;

import { ContentState, EditorState, Modifier } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import styled from 'styled-components';
import DOMPurify from 'dompurify';

const toolbarOptions = {
  options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'history'],
  inline: {
    options: ['bold', 'italic', 'underline']
  },
  blockType: {
    inDropdown: true
  },
  fontSize: {
    className: 'custom-fontsize'
  },
  list: {
    inDropdown: false
  },
  textAlign: {
    inDropdown: false
  }
};

function WYSIWYG({ editorState, onEditorStateChange, placeholder }) {
  const handlePastedText = (text, html, state) => {
    if (!html) return false;

    if (html.length > 100000) {
      alert('Pasted content is too large. Please paste smaller portions.');
      return true;
    }

    try {
      // const cleanHtml = DOMPurify.sanitize(html, {
      //   ALLOWED_TAGS: ['p', 'br', 'b', 'i', 'u', 'ul', 'ol', 'li', 'strong', 'em'],
      //   ALLOWED_ATTR: []
      // });
      const cleanHtml = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
          'p',
          'br',
          'b',
          'i',
          'u',
          'ul',
          'ol',
          'li',
          'strong',
          'em',
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'h6',
          'span',
          'div',
          'blockquote',
          'pre',
          'code',
          'a'
        ],
        ALLOWED_ATTR: [
          'style',
          'class',
          'href',
          'target',
          'rel',
          'id',
          'name' // Common attributes for formatting
        ],
        // Add custom rules to preserve inline styles
        ADD_ATTR: ['style']
      });

      const blocksFromHtml = htmlToDraft(cleanHtml);
      if (!blocksFromHtml || !blocksFromHtml.contentBlocks) return false;

      const { contentBlocks, entityMap } = blocksFromHtml;
      const fragment = ContentState.createFromBlockArray(contentBlocks, entityMap).getBlockMap();

      const newContentState = Modifier.replaceWithFragment(
        state.getCurrentContent(),
        state.getSelection(),
        fragment
      );

      const newEditorState = EditorState.push(state, newContentState, 'insert-fragment');

      onEditorStateChange(
        EditorState.forceSelection(newEditorState, newContentState.getSelectionAfter())
      );

      return true;
    } catch (error) {
      console.warn('Paste processing failed, falling back to plain text:', error);
      return false;
    }
  };

  return (
    <QuillView>
      <Editor
        editorState={editorState}
        toolbar={toolbarOptions}
        handlePastedText={handlePastedText}
        wrapperClassName="rdw-editor-wrapper"
        editorClassName="rdw-editor-main"
        toolbarClassName="rdw-editor-toolbar"
        onEditorStateChange={onEditorStateChange}
        placeholder={placeholder}
      />
    </QuillView>
  );
}

export default WYSIWYG;

const QuillView = styled.div`
  width: 100%;
  margin-top: 10px;

  .rdw-editor-wrapper {
    margin-top: -6px;
    border-radius: 0 0 16px 16px;
    background-color: ${({ theme }) => theme.colors.inputBackground};
  }

  .rdw-editor-toolbar {
    border-bottom: 1px solid ${({ theme }) => theme.colors.line};
    background-color: ${({ theme }) => theme.colors.inputBackground};
  }

  .rdw-editor-main {
    min-height: 300px;
    max-height: 400px; 
    padding: 0 10px;
    margin-top: -6px;
    border: none;
    overflow: auto;
    border-radius: 0 0 16px 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.line};
    background-color: ${({ theme }) => theme.colors.inputBackground};
  }

  .rdw-option-wrapper {
    background-color: ${({ theme }) => theme.colors.inputBackground};
  }

  .rdw-option-active {
    background-color: ${({ theme }) => theme.colors.inputBackground};
  }

  .ql-editor {
    border: none;
    border-radius: 0 0 16px 16px;
    background-color: ${({ theme }) => theme.colors.inputBackground};
  }

  .ql-toolbar {
    border: none;
    border-radius: 16px 16px 0 0;
    background-color: ${({ theme }) => theme.colors.inputBackground};
    border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  }

  .ql-container {
    border: none;
    min-height: 150px;
    margin-bottom: 30px;
  }
`;